import { ThemeColorsKeys } from '@agria/theme/src/styles/tokens/colors';

interface ThemeConfig {
  backgroundColor: ThemeColorsKeys;
  color: ThemeColorsKeys;
  includeInverseFocus: boolean;
  includePhoneNumber: boolean;
}

const themeConfig: ThemeConfig = {
  backgroundColor: 'brandOne100',
  color: 'brandTwo100',
  includeInverseFocus: true,
  includePhoneNumber: true,
};

export default themeConfig;
